import nodataicon from "../../../assets/images/icons/no data.svg"
const NoData = ({responeMessage}) => {
  return (
    <div className="text-center mt-5">
   <img src={nodataicon} height="250px" />
   <h2 className="mt-3">{responeMessage}</h2>
  </div>
  )
}

export default NoData